import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Segment, Header, Divider, Form, TextArea, Table, Input } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';

class FacilityInventory extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onDayChange = this.onDayChange.bind(this);
    this.onRateChange = this.onRateChange.bind(this);
    this.onSpotsBlur = this.onSpotsBlur.bind(this);
  }

  onChange(e, { name, value }) {
    const { onChange, inventory } = this.props;
    const i = { ...inventory, [name]: value };
    onChange(e, i);
  }

  onRateChange(e, { id, name, value }) {
    console.log(id, name, value);
    const { onChange, inventory } = this.props;
    const blocks = [...inventory.blocks];
    const idx = blocks.findIndex((d) => d.id === name);
    blocks[idx] = { ...blocks[idx], [id]: numeral(Math.abs(value)).format('0,0.00') };
    const i = { ...inventory, blocks };
    console.log(i);
    onChange(e, i);
  }

  onDayChange(e, { id, name, value }) {
    console.log(id, name, value);
    const { onChange, inventory } = this.props;
    const blocks = [...inventory.blocks];
    const idx = blocks.findIndex((d) => d.id === name);
    blocks[idx] = { ...blocks[idx], [id]: value };
    const i = { ...inventory, blocks };
    console.log(i);
    onChange(e, i);
  }

  onSpotsBlur(e, { id, name, value }) {
    console.log(id, name, value);
    const { onChange, inventory } = this.props;
    const blocks = [...inventory.blocks];
    const idx = blocks.findIndex((d) => d.id === name);
    if (value >= blocks[idx].reservedSpots) {
      blocks[idx] = { ...blocks[idx], [id]: Math.abs(value) };
    } else {
      blocks[idx] = { ...blocks[idx], [id]: blocks[idx].reservedSpots };
    }
    const i = { ...inventory, blocks };
    console.log(i);
    onChange(e, i);
  }

  render() {
    const { inventory } = this.props;
    const { facility, venue, blocks, directions } = inventory;
    const sortBlocks = (a, b) => moment.utc(a.startDate) - moment.utc(b.startDate) || moment.utc(b.endDate) - moment.utc(a.endDate);
    return (
      <Segment>
        <Header as="h3" content={`${facility.name} - ${facility.address}`} />
        <Divider horizontal>Inventory Details</Divider>
        <Form>
          <Form.Field>
            <label>Directions to {venue.name}</label>
            <TextArea placeholder="Directions" name="directions" value={directions} onChange={this.onChange} />
          </Form.Field>
          <Form.Field>
            <label>Daily Inventory Count</label>
            <Table>
              <Table.Header>
                <Table.HeaderCell>Block</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Header>
              <Table.Body>
                {blocks.sort(sortBlocks).map((block, idx) => (
                  <Table.Row key={idx}>
                    <Table.Cell>{block.name}</Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        <Input
                          id="spots"
                          name={block.id}
                          label={`Inventory (Min: ${block.reservedSpots})`}
                          value={block.spots}
                          onChange={this.onDayChange}
                          onBlur={(e) => this.onSpotsBlur(e, { id: 'spots', name: block.id, value: block.spots })}
                        />
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        <Input
                          id="rate"
                          name={block.id}
                          label="Rate"
                          value={block.rate}
                          onChange={this.onDayChange}
                          onBlur={(e) => this.onRateChange(e, { id: 'rate', name: block.id, value: block.rate })}
                        />
                      </Form.Field>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

FacilityInventory.propTypes = {
  inventory: PropTypes.object.isRequired,
};

export default FacilityInventory;
